<div class="tw-flex tw-flex-col tw-rounded-b-xl">
  <div class="tw-px-5 tw-py-8 tw-h-full sm:tw-px-0">
    <form>
      <app-input
        class="category-add-edit-input"
        [value]="form.controls.categoryName.value"
        [label]="'categoryName' | i18n"
        [isRequired]="true"
        [placeholder]="'inputCategoryName' | i18n"
        (outputValue)="onCategoryNameChange($event)"
      >
      </app-input>
    </form>
  </div>
  <div class="tw-flex tw-py-6 tw-px-5 tw-rounded-b-xl tw-justify-end sm:tw-px-0">
    <app-gloss-button
      class="tw-w-1/2 sm:tw-w-full"
      [options]="saveButtonOptions"
      fontClass="tw-text-xl tw-font-medium tw-text-dt-slate-0 sm:tw-text-lg"
    ></app-gloss-button>
  </div>
</div>
